import styled from "styled-components";

const CommonButton = styled.button`
  font-size: 20px;
  padding: 10px 23px;
  color: #0d6efd;
  background-color: #fff;
  border: 2px solid #0d6efd;
  border-radius: 35px;
  transition: 0.4s ease;
  &:hover {
    color: white;
    background-color: #0d6efd;
  }
`;
export default CommonButton;
